import { useFormState } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonVariant } from '#components/button';
import { useIsFrontendStyleDefault } from '#base/hooks';

const ForgotPasswordFormSubmit = () => {
  const formState = useFormState();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  return (
    <Button
      variant={isFrontendStyleDefault ? ButtonVariant.black : ButtonVariant.vividCrimson}
      type="submit"
      textUppercase
      disabled={formState.submitting}
      isVisibleLoader={formState.submitting}
    >
      <FormattedMessage defaultMessage="Recover my password" />
    </Button>
  );
};

export { ForgotPasswordFormSubmit };
